var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5725 2.10065L8.08028 5.93198C7.99383 6.03843 7.97719 6.15481 8.03041 6.28121C8.08371 6.40748 8.18009 6.47087 8.31985 6.47087H10.5549V18.9229C10.5549 19.0161 10.5847 19.0926 10.6446 19.1524C10.7044 19.2122 10.781 19.2422 10.8741 19.2422H12.7897C12.8828 19.2422 12.9593 19.2123 13.0191 19.1524C13.0789 19.0925 13.1088 19.016 13.1088 18.9229V6.4708H15.3438C15.477 6.4708 15.5734 6.4073 15.6331 6.28111C15.6865 6.1546 15.6663 6.03822 15.5734 5.93177L12.041 2.10044C11.9746 2.03394 11.8949 2.00077 11.8017 2.00077C11.7154 2.00077 11.639 2.03415 11.5725 2.10065Z",
    fill: "#303238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5533 17.5176V17.5302H8.31835C8.18512 17.5302 8.08873 17.5938 8.02906 17.72C7.9756 17.8465 7.99581 17.9629 8.08873 18.0692L11.6211 21.9005C11.6517 21.9313 11.6851 21.9548 11.7214 21.9713C11.7638 21.9906 11.8101 22.0003 11.8604 22.0003C11.9467 22.0003 12.0231 21.9668 12.0896 21.9003L15.5818 18.069C15.6683 17.9627 15.6849 17.8463 15.6317 17.7198C15.5784 17.5936 15.482 17.5302 15.3422 17.5302H13.1072V17.5176H10.5533Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowV);
export default __webpack_public_path__ + "static/media/arrow-v.6106742e6e148b400c4173d257a626fc.svg";
export { ForwardRef as ReactComponent };